// extracted by mini-css-extract-plugin
export default {"productDetails":"ProductDetails_productDetails__8qvh-"};